/**
 * <pvz-localization>
 *
 * 国 / 通貨 (と言語) のセレクタ。snippets/pvz-localization.liquid が出力する
 * マークアップを制御する。
 *
 * Dawn の localization-form.js は `.header-wrapper` と `.menu-drawer` を
 * 無条件に querySelector するため、それらを持たないこのテーマでは例外になる。
 * ここでは同じ役割を依存なしで実装している。
 *
 * 選択すると隠しフィールド (country_code / locale_code) に値を入れて
 * localization フォームを送信し、Shopify がマーケットを切り替える。
 */
if (!customElements.get('pvz-localization')) {
  customElements.define(
    'pvz-localization',
    class PvzLocalization extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.toggle = this.querySelector('[data-pvz-l10n-toggle]');
        this.panel = this.querySelector('[data-pvz-l10n-panel]');
        this.input = this.querySelector('[data-pvz-l10n-input]');

        if (!this.form || !this.toggle || !this.panel || !this.input) return;

        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      get links() {
        return Array.from(this.querySelectorAll('.pvz-l10n__link'));
      }

      setOpen(open) {
        this.toggle.setAttribute('aria-expanded', String(open));
        this.panel.hidden = !open;

        if (open) {
          document.addEventListener('click', this.onDocumentClick);
          // フッターなど画面下にあるときにパネルが見切れないようにする
          this.panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } else {
          document.removeEventListener('click', this.onDocumentClick);
        }
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.setOpen(false);
      }

      onClick(event) {
        const link = event.target.closest('.pvz-l10n__link');
        if (!link) return;

        event.preventDefault();
        this.input.value = link.dataset.value;
        this.form.submit();
      }

      onKeyDown(event) {
        if (event.key === 'Escape') {
          if (!this.isOpen) return;
          event.stopPropagation();
          this.setOpen(false);
          this.toggle.focus();
          return;
        }

        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

        const links = this.links;
        if (links.length === 0) return;

        event.preventDefault();
        if (!this.isOpen) this.setOpen(true);

        const current = links.indexOf(document.activeElement);
        let next;
        if (event.key === 'ArrowDown') {
          next = current < links.length - 1 ? current + 1 : 0;
        } else {
          next = current > 0 ? current - 1 : links.length - 1;
        }
        links[next].focus();
      }
    }
  );
}
